import React, { useEffect, useState } from "react";
import './ScaleUp.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import {Pagination,Autoplay} from 'swiper/modules';
import 'swiper/css/pagination';
import scaleupImage1 from '../../utils/assets/images/scaleup1.png'
import scaleupImage2 from '../../utils/assets/images/scaleup2.png'
import scaleupImage3 from '../../utils/assets/images/scaleup3.png'
import scaleupImage4 from '../../utils/assets/images/scaleup4.png'
import 'aos/dist/aos.css';
const ScaleUPSection = () => {
    const scaleup = [{
        id:1,
        image:scaleupImage1,
        title:"Strategic Location",
        description:  ["Vast local offtake opportunities and proximity to global markets, particularly Europe, through the main ports on Red Sea and Mediterranean"] 
    },
    {
        id:2,
        image:scaleupImage2,
        title:"Strong Industrial Base",
        description:["Strong recent increase of industrial clusters across various industries enables companies at the heart of Hydrogen transformation to prosper"]
    },
    {
        id:3,
        image:scaleupImage3,
        title:"High Accessibility",
        description:["Well-established basic infrastructure in SCZONE","Strategically placed ports with high Green Bunkering potential and good connectivity","Available export infrastructure through potential retrofitting of LNG pipes"]
    },
    {
        id:4,
        image:scaleupImage4,
        title:"Renewable Capacity",
        description:["Ample wind & solar resources favorably positioning Egypt for GH2 production with average wind speeds showing great potential for wind projects"]
    }
]
const [state, setState] = useState({
    activeIndex:0,
    show:false
})
const [swiper, setSwiper] = useState(null)
   return (
        <>
            <div className='scale-up-section' id='scale-up' >
                <div className='ctr'>
                    <div className='title-symbol'>
                        <div className='page-symbole'></div>
                        <div className='title'> Scale-up in Egypt</div>
                    </div>
                    <p>Egypt has favorable conditions that foster the development of the Green Hydrogen and can potentially be one of the most competitive places to deliver H2 to Europe </p>
                    <div className="scale-up-slider">
                        <div className="scale-up-slider-title">
                            Key Enablers for Hydrogen Scale-up in Egypt
                        </div>
                        <div className="scale-up-swiper">
                            <Swiper
                              modules={[Pagination,Autoplay]} 
                                spaceBetween={50}
                                slidesPerView={1}
                                pagination={{ clickable: true }}
                                dir="ltr"
                                autoplay={{
                                    "delay": 3700,
                                    "disableOnInteraction": false
                                  }} 
                                  onSlideChange={(e) => {
                                    setState({
                                        activeIndex:swiper.activeIndex,
                                        show:true
                                    })
                                  }}
                                  onSwiper={(s) => setSwiper(s)}
                            >
                                {scaleup?.map(item => (
                                    <SwiperSlide key={item?.id} >
                                       <div className="slide-wrapper">
                                        <div className="row slide-wrapper-row">
                                            <div className="col-lg-4 col-md-6 col-12"><div className="slide-image-title">
                                            <img className={state.activeIndex == item?.id - (parseInt(1)) ? "active-step-image":"step-image"} src={item?.image}/>
                                            <div className="slide-step" >
                                                <div className={state.activeIndex == item?.id - (parseInt(1)) ? item?.id == 2 ? "active-step2-id":"active-step-id":"step-id"} >{item?.id}</div>
                                                <div>{item?.title}</div>
                                            </div>

                                        </div></div>
                                            <div className="col-lg-6 col-md-6 col-12">
                                            {/* <div className={state.activeIndex == item?.id - (parseInt(1))?"active-slide-desc":"slide-desc"}> */}
                                                  <div className="slide-desc">
                                            {item?.description?.map((desc,index) => (
                                                <div className="desc" key={index}>{desc}</div>
                                            ))}
                                        </div></div>
                                        </div>
                                         
                                      </div>
                                    </SwiperSlide>

                                ))}     
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div></>
    )
}
export default ScaleUPSection